export default "__VITE_ASSET__a5fde356__"